import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ChipTone, StatusKind, statusChip } from './status-chip';

/**
 * A status pill in the dashboards' chip style. Either map a known status
 * (`kind` + `value`, e.g. a reservation's "rejected" → "Declined" in
 * trinidad) or give a `tone` and project the text.
 */
@Component({
  selector: 'admin-status-chip',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `<span class="chip" [class]="'chip tone-' + chipTone">{{ chipLabel }}<ng-content></ng-content></span>`,
  styles: [
    `
      :host {
        display: inline-flex;
      }
      .chip {
        display: inline-flex;
        align-items: center;
        padding: 3px 9px;
        border-radius: 9999px;
        font-family: var(--cnt-font-button, sans-serif);
        font-size: 0.65rem;
        font-weight: 700;
        line-height: 1.3;
        letter-spacing: 0.1em;
        text-transform: uppercase;
        white-space: nowrap;
      }
      .tone-green {
        background: rgba(41, 93, 66, 0.14);
        color: #295d42;
      }
      .tone-gold {
        background: rgba(251, 215, 132, 0.45);
        color: #8a5a06;
      }
      .tone-trinidad {
        background: rgba(227, 83, 13, 0.13);
        color: #9a3f0a;
      }
      .tone-grey {
        background: rgba(34, 34, 34, 0.08);
        color: #555;
      }
      .tone-teal {
        background: rgba(59, 123, 122, 0.14);
        color: #2f6261;
      }
    `,
  ],
})
export class AdminStatusChipComponent {
  @Input() kind?: StatusKind;
  @Input() value?: string | null;
  /** With projected text instead of kind/value. */
  @Input() tone: ChipTone = 'grey';

  get chipTone(): ChipTone {
    return this.kind ? statusChip(this.kind, this.value).tone : this.tone;
  }

  get chipLabel(): string {
    return this.kind ? statusChip(this.kind, this.value).label : '';
  }
}
